module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "krossing_object",
    class: [{
        'active': _vm.compActive
      },
      {
        'enable-hover': _vm.enableHover
      },
      {
        'disabled': _vm.compIsDisabled
      },
      {
        'is_box': _vm.compIsBox
      },
      [_vm.compMaterial ? _vm.compMaterial.key : '']
    ],
    style: (_vm.compIsBox && _vm.compWood && _vm.compActive ? {
      flexBasis: _vm.px(_vm.compWidth),
      backgroundImage: 'url(/images/' + _vm.compWood + '.jpg)',
    } : {
      flexBasis: _vm.px(_vm.compWidth),
      backgroundColor: _vm.compIsBox && _vm.compMaterial && _vm.compActive ? _vm.compFrontalMaterial.css_color : ''
    }),
    on: {
      "click": _vm.emitOnClick
    }
  }, [(_vm.compIsBox) ? _c('img', {
    staticClass: "box_img",
    attrs: {
      "src": "/images/box.svg"
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.image && _vm.compActive && _vm.imagepath) ? _c('img', {
    attrs: {
      "src": _vm.imagepath + _vm.compImage
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6077cb19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/KrossingObject.vue
// module id = 638
// module chunks = 0